import React, {Component} from 'react';
import PropTypes from "prop-types";

/**
 * Component to render Table Rows,
 * Used by DetailTable and SelectionTable
 *
 * @example
 * <TableRow
 *   key={key}
 *   value={key}
 *   faded={isFaded}
 *   selected={isSelected}
 *   onSelect={this.props.onSelect}
 *   onComparison={this.props.onComparison}
 *   children={cells}
 *  />
 */
export default class TableRow extends Component {

  static propTypes = {
    children: PropTypes.node,
    highlighted: PropTypes.bool,
    faded: PropTypes.bool,
    value: PropTypes.any,
    onSelect: PropTypes.func,
    onComparison: PropTypes.func,
  };

  dispatchOnSelect = () => {
    if (this.props.onSelect) {
      this.props.onSelect(this.props.value)
    }
  }

  dispatchOnComparison = () => {
    if (this.props.onComparison) {
      this.props.onComparison(this.props.value)
    }
  }

  handleClickEvent = (event) => {
    if (event.metaKey || event.ctrlKey) {
      this.dispatchOnComparison();
    } else {
      this.dispatchOnSelect();
    }
  };

  render() {
    let combinedClassName = 'selectable-row';
    combinedClassName += this.props.highlighted ? ' bg-tertiary' : '';
    combinedClassName += this.props.faded ? ' faded' : '';

    return (
      <tr
        role="row"
        tabIndex={this.props.highlighted ? 0: -1}
        aria-selected={this.props.highlighted}
        className={combinedClassName}
        onClick={this.handleClickEvent}
        children={this.props.children}
      />
    );
  }
}
